import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWriting: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconWriting"><Path d="M18.5 2.5L11.5 9.5V12.5H14.5L21.5 5.5L18.5 2.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M8.5 12.5H5.5C4.39543 12.5 3.5 13.3954 3.5 14.5C3.5 15.6046 4.39543 16.5 5.5 16.5H16.5C17.6046 16.5 18.5 17.3954 18.5 18.5C18.5 19.6046 17.6046 20.5 16.5 20.5H11.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconWriting;
